import { RPCs } from "../../../services/rpc.js";
import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { ALL_REGIONS_ID } from "../constants.js";
import "react";
import { Avatar } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { getInitials } from "@therms/web-js";
//#region src/modules/Regions/shared/SelectRegion.tsx
var ADDITIONAL_OPTIONS = [{ id: ALL_REGIONS_ID }];
var Base = ({ region }) => {
	if (!region) return null;
	if (region.id === "rgn-") return /* @__PURE__ */ jsx("div", { children: "All Regions" });
	const { name, primaryImageUrl, timezone } = region;
	return /* @__PURE__ */ jsxs("div", {
		className: "space-x-base flex items-center",
		children: [/* @__PURE__ */ jsx(Avatar, {
			url: getTHERMSImageThumbnailUrl(primaryImageUrl),
			symbol: getInitials(name),
			size: "xs"
		}), /* @__PURE__ */ jsxs("div", {
			className: "truncate",
			children: [/* @__PURE__ */ jsx("div", {
				className: "truncate",
				children: name
			}), /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate text-sm",
				children: timezone
			})]
		})]
	});
};
var SelectedSingle = (region) => /* @__PURE__ */ jsx(Base, { region });
var SelectedMulti = (region, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsx("div", {
		className: "px-sm max-w-full",
		children: /* @__PURE__ */ jsx(Base, { region })
	})
});
var ListItem = (regionOption) => /* @__PURE__ */ jsx(Base, { region: regionOption });
var responseOptionsExtractor = (data) => data?.regions;
var SelectRegion = ({ active = true, allowAllOption, idFilter, limit = 25, multi, value, ...atalayaSelectProps }) => /* @__PURE__ */ jsx(SelectAsyncRPC, {
	RenderListItem: ListItem,
	RenderSelectedMulti: SelectedMulti,
	RenderSelectedSingle: SelectedSingle,
	additionalOptions: allowAllOption ? ADDITIONAL_OPTIONS : void 0,
	args: {
		active,
		idFilter
	},
	idProp: "id",
	limit,
	multi,
	optionLabelExtractor: ({ name }) => name,
	optionValueExtractor: ({ id }) => id,
	request: RPCs.Regions.GetRegionsList.v1,
	requestFilterProp: "idFilter",
	responseOptionsExtractor,
	value,
	...atalayaSelectProps
});
//#endregion
export { SelectRegion };

//# sourceMappingURL=SelectRegion.js.map